import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=e0ff4958"
import script from "./SidePanel.ts?vue&type=script&lang=ts&external"
export * from "./SidePanel.ts?vue&type=script&lang=ts&external"
import style0 from "../../styles/SidePanel/side-panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports